import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
export const getRequestMetadata = () => ({
  referrer: window.location.href,
  origin: window.location.origin
});
export default createRpcClientV2({
  hubHttpClient: noAuthHttp
});